// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import httpFactory from "./utils/http"
import plugins from './utils/plugins'
import { Toast } from 'vant'

import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)
Vue.use(Toast);


import ElementUI from 'element-ui'
import '@/assets/css/element.scss'
Vue.use(ElementUI);

import PullRefresh from "./components/mobile/PullRefresh"
Vue.component('PullRefresh', PullRefresh)

Vue.config.productionTip = false

const http = httpFactory.build('studentToken')

Vue.prototype.getCookie = function (name) {
  let strCookies = document.cookie;
  let array = strCookies.split(';');
  for (var i = 0; i < array.length; i++) {
      var item = array[i].split("=");
      if (item[0].trim('') == name) {
          return item[1];
      }
  }
  return null;
}

Date.prototype.format = function (fmt) {
  var o = {
      "M+": this.getMonth() + 1, //月份   
      "d+": this.getDate(), //日   
      "h+": this.getHours(), //小时   
      "m+": this.getMinutes(), //分   
      "s+": this.getSeconds(), //秒   
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度   
      "S": this.getMilliseconds() //毫秒   
  };
  if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

Vue.prototype.$messagePromise = function (msg, config) {
  return new Promise(resolve => {
      config = Object.assign({
          message: msg,
          type: 'info',
          duration: 3000,
          showClose: false,
          onClose: function () {
              resolve();
          },
      },
          config
      );
      this.$message(config);
  });
};
Vue.prototype.$success = function (msg, config = {}) {
  config.type = 'success';
  return this.$messagePromise(msg, config);
};
Vue.prototype.$info = function (msg, config = {}) {
  config.type = 'info';
  return this.$messagePromise(msg, config);
};
let vue
if (!localStorage.getItem('studentToken')) {
	let sso = Vue.prototype.getCookie('ssotoken')
	if (sso) {
    let param = {
      ssotoken: sso
    }
    $.ajax({
      type: 'post',
      url: process.env.VUR_APP_LOGING_URL + '/api/app/getToken',
      async: false,
      data: {
        data: JSON.stringify(param)
      },
      success: function (res) {
        let data = res.data
        if (res.code == 200) {
          if (data.is_collect_data) {
            sessionStorage.setItem('pr_webToken', data.remember_token)
            router.push({
              name: 'RegistInformation'
            })
          } else {
            Vue.prototype.$success('登录成功')
            localStorage.setItem('studentToken', data.remember_token)
            localStorage.setItem('userInfo', JSON.stringify(data))
          }
        } else {
          console.log('失败')
        }
        vue = new Vue({
          router,
          render: h => h(App)
        })
        vue.$mount('#app')

      },
      error: function (msg) {
        vue = new Vue({
          router,
          render: h => h(App)
        })
        vue.$mount('#app')
        console.log('请求失败')

      }
    })
  }
}


Vue.prototype.$http = http
Vue.prototype.$pub = plugins

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })

vue = new Vue({
	router,
  render: h => h(App)
})
vue.$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js